import { CircularProgress, Typography } from '@material-ui/core'
import React from 'react'

export interface IProps {
  message?: ReactNode | string
}

export const LoaderSpinner: React.FC<IProps> = ({ message }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <>
      <br />
      <CircularProgress />
      {typeof message === 'string' ? (
        <Typography variant="subtitle1">{message}</Typography>
      ) : (
        message
      )}
    </>
  </div>
)
